import {
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MachineName from "./MachineName";
import Network from "./Network";
import DeviceConfiguration from "./DeviceConfiguration";
import Fleet from "./Fleet";
import useStore from "../../State";
import JobConnection from "./JobConnection";
import Finish from "./Finish";
import {
  AdminPanelSettings,
  Cable,
  CloudSync,
  PrecisionManufacturing,
} from "@mui/icons-material";
import DeviceChoice from "./DeviceChoice";
import Robby from "./Robby";
import RobbyConnection from "./RobbyConnection";

const Home: React.FC = () => {
  document.body.style.backgroundColor = "white";
  const { t } = useTranslation();

  const user = useStore((state: any) => state.user);

  const [activeStep, setActiveStep] = useState<number>(0);
  const steps: () => string[] = () => {
    if (stepsChoice === "first") {
      return [
        t("nameYourMachine"),
        t("fleet"),
        t("networkConfiguration"),
        t("robby"),
        t("deviceConfiguration"),
      ];
    } else {
      if (stepsChoice === "robby") {
        return [
          t("robby"),
          t("deviceChoice"),
          t("deviceConfiguration"),
          t("finish"),
        ];
      } else {
        //notFirst
        return [
          t("networkConfiguration"),
          t("robby"),
          t("deviceChoice"),
          t("deviceConfiguration"),
          t("finish"),
        ];
      }
    }
  };

  const [values, setValues] = useState<any>({
    name: "",
    userId: "",
    fleetId: "",
    deviceId: "",
    configuration: {},
    robby: {},
  });

  const handleBack = () => {
    setStepsChoice("");
  };

  const handleSaveDeviceid = (deviceid: string) => {
    setValues({ ...values, deviceId: deviceid });
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleSaveName = (serialCode: string, userId: string) => {
    setValues({
      ...values,
      serialCode: serialCode,
      userId: userId,
    });
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleSaveFleet = (fleetId: string) => {
    setValues({ ...values, fleetId: fleetId });
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleSaveConfiguration = (configuration: any) => {
    setValues({ ...values, configuration: configuration });
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleSaveRobby = (robby: any) => {
    setValues({ ...values, robby: robby });
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const [stepsChoice, setStepsChoice] = useState<
    "" | "first" | "notFirst" | "robby"
  >("");

  if (stepsChoice === "") {
    return (
      <Grid
        container
        spacing={2}
        direction="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
      >
        <Grid item>
          <AdminPanelSettings style={{ fontSize: "64px" }} />
        </Grid>
        <Grid item>
          <Typography variant="h5">{t("configurationType")}</Typography>
        </Grid>
        <Grid item>
          <Typography>{t("configurationTypeDescription")}</Typography>
        </Grid>
        <Grid
          container
          item
          spacing={4}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <Grid
            container
            item
            spacing={4}
            alignItems="center"
            justifyContent="center"
          >
            {(user.admin ? ["first", "notFirst"] : ["notFirst"]).map(
              (i: string, index: number) => {
                return (
                  <Grid key={index} item xs={12} md={6} lg={4} xl={3}>
                    <Card variant="outlined">
                      <CardActionArea
                        data-testid={i}
                        onClick={() =>
                          setStepsChoice(
                            i as "" | "first" | "notFirst" | "robby"
                          )
                        }
                      >
                        <CardContent
                          style={{
                            marginTop: "40px",
                            marginBottom: "40px",
                            textAlign: "center",
                          }}
                        >
                          <Grid container direction="column" spacing={2}>
                            <Grid item>
                              {i === "first" && (
                                <Cable style={{ fontSize: "32px" }} />
                              )}
                              {i === "notFirst" && (
                                <CloudSync style={{ fontSize: "32px" }} />
                              )}
                              {i === "robby" && (
                                <PrecisionManufacturing
                                  style={{ fontSize: "32px" }}
                                />
                              )}
                            </Grid>
                            <Grid item>
                              <Typography variant="h5">
                                {i === "first" && t("firstConfiguration")}
                                {i === "notFirst" && t("otherConfiguration")}
                                {i === "robby" && t("robby")}
                              </Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                );
              }
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid container spacing={2} flexDirection="column">
        <Grid item>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps().map((label: string) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grid>
        {/* ADMIN => PRIMA CONFIGURAZIONE */}
        {user.admin && stepsChoice === "first" && (
          <Grid item>
            {activeStep === 0 && (
              <MachineName
                handleNext={handleSaveName}
                handleBack={handleBack}
              />
            )}
            {activeStep === 1 && <Fleet handleNext={handleSaveFleet} />}
            {activeStep === 2 && (
              <Network handleNext={handleSaveConfiguration} />
            )}
            {activeStep === 3 && (
              <Robby
                handleBack={() =>
                  setActiveStep((prevActiveStep) => prevActiveStep - 1)
                }
                handleNext={handleSaveRobby}
                handleSkip={() => {
                  setActiveStep((prevActiveStep) => prevActiveStep + 1);
                }}
              />
            )}
            {activeStep === 4 && (
              <DeviceConfiguration
                values={values}
                handleNext={(deviceId: string) => {
                  handleSaveDeviceid(deviceId);
                  setStepsChoice("robby");
                  setActiveStep(0);
                }}
              />
            )}
          </Grid>
        )}
        {/* ADMIN => AGGIORNAMENTO CREDENZIALI */}
        {user.admin && stepsChoice === "notFirst" && (
          <Grid item>
            {activeStep === 0 && (
              <Network
                handleNext={handleSaveConfiguration}
                handleBack={handleBack}
              />
            )}
            {activeStep === 1 && (
              <Robby
                handleBack={() =>
                  setActiveStep((prevActiveStep) => prevActiveStep - 1)
                }
                handleNext={handleSaveRobby}
                handleSkip={() => {
                  setActiveStep((prevActiveStep) => prevActiveStep + 1);
                }}
              />
            )}
            {activeStep === 2 && (
              <DeviceChoice
                handleNext={handleSaveDeviceid}
                handleBack={() =>
                  setActiveStep((prevActiveStep) => prevActiveStep - 1)
                }
              />
            )}
            {activeStep === 3 && (
              <JobConnection
                values={values}
                handleNext={() =>
                  setActiveStep((prevActiveStep) => {
                    if (prevActiveStep === 4) {
                      return 4;
                    } else {
                      return prevActiveStep + 1;
                    }
                  })
                }
              />
            )}
            {activeStep === 4 && (
              <Finish
                robby={() => {
                  setStepsChoice("robby");
                  setActiveStep(0);
                }}
              />
            )}
          </Grid>
        )}
        {/* ADMIN => ROBBY */}
        {user.admin && stepsChoice === "robby" && (
          <Grid item>
            {activeStep === 0 && (
              <Robby handleBack={handleBack} handleNext={handleSaveRobby} />
            )}
            {activeStep === 1 && (
              <DeviceChoice
                handleNext={handleSaveDeviceid}
                handleBack={() =>
                  setActiveStep((prevActiveStep) => prevActiveStep - 1)
                }
              />
            )}
            {activeStep === 2 && (
              <RobbyConnection
                values={values}
                handleNext={() =>
                  setActiveStep((prevActiveStep) => {
                    if (prevActiveStep === 3) {
                      return 3;
                    } else {
                      return prevActiveStep + 1;
                    }
                  })
                }
              />
            )}
            {activeStep === 3 && <Finish />}
          </Grid>
        )}
        {/* USER => AGGIORNAMENTO CREDENZIALI */}
        {!user.admin && stepsChoice === "notFirst" && (
          <Grid item>
            {activeStep === 0 && (
              <Network
                handleNext={handleSaveConfiguration}
                handleBack={handleBack}
              />
            )}
            {activeStep === 1 && (
              <Robby
                handleBack={() =>
                  setActiveStep((prevActiveStep) => prevActiveStep - 1)
                }
                handleNext={handleSaveRobby}
                handleSkip={() => {
                  setActiveStep((prevActiveStep) => prevActiveStep + 1);
                }}
              />
            )}
            {activeStep === 2 && (
              <DeviceChoice
                handleNext={handleSaveDeviceid}
                handleBack={() =>
                  setActiveStep((prevActiveStep) => prevActiveStep - 1)
                }
              />
            )}
            {activeStep === 3 && (
              <JobConnection
                values={values}
                handleNext={() =>
                  setActiveStep((prevActiveStep) => {
                    if (prevActiveStep === 4) {
                      return 4;
                    } else {
                      return prevActiveStep + 1;
                    }
                  })
                }
              />
            )}
            {activeStep === 4 && (
              <Finish
                robby={() => {
                  setStepsChoice("robby");
                  setActiveStep(0);
                }}
              />
            )}
          </Grid>
        )}
        {/* USER => ROBBY */}
        {!user.admin && stepsChoice === "robby" && (
          <Grid item>
            {activeStep === 0 && (
              <Robby handleBack={handleBack} handleNext={handleSaveRobby} />
            )}
            {activeStep === 1 && (
              <DeviceChoice
                handleNext={handleSaveDeviceid}
                handleBack={() =>
                  setActiveStep((prevActiveStep) => prevActiveStep - 1)
                }
              />
            )}
            {activeStep === 2 && (
              <RobbyConnection
                values={values}
                handleNext={() =>
                  setActiveStep((prevActiveStep) => {
                    if (prevActiveStep === 3) {
                      return 3;
                    } else {
                      return prevActiveStep + 1;
                    }
                  })
                }
              />
            )}
            {activeStep === 3 && <Finish />}
          </Grid>
        )}
      </Grid>
    );
  }
};

export default Home;
